// = require action_cable

import { createConsumer } from '@rails/actioncable';

export default createConsumer();
